/* eslint-disable @typescript-eslint/no-explicit-any */
import * as amplitude from "@amplitude/analytics-browser";
import { useActiveAccount } from "thirdweb/react";

export const trackUserEvent = (
  event: string,
  properties?: Record<string, any>
) => {
  amplitude.track(event, { ...properties });
};

export const useTrackUserEvent = () => {
  const activeAccount = useActiveAccount();
  const track = (event: string, properties?: Record<string, any>) =>
    trackUserEvent(event, {
      walletAddress: activeAccount?.address,
      ...properties,
    });

  return track;
};
